export class FirebaseConnection {
  public constructor(private _firebase: any) {
  }

  public get firebase(): any {
    return this._firebase;
  }

  public get authUid(): string {
    const uid: string = this._firebase.auth().currentUser!.uid;
    return uid;
  }
}
